import { render, staticRenderFns } from "./BulkSeniorMemberPayment.vue?vue&type=template&id=15a8d171"
import script from "./BulkSeniorMemberPayment.vue?vue&type=script&lang=js"
export * from "./BulkSeniorMemberPayment.vue?vue&type=script&lang=js"
import style0 from "./BulkSeniorMemberPayment.vue?vue&type=style&index=0&id=15a8d171&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports